import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)
let router = new Router({
  mode: 'history',
  routes: [
    {path: '/', name: 'HomePage', component: (resolve) => require(['@/page/HomePage'], resolve), meta: {title: '信息补充'}},
    {path: '/bindPhone', name: 'bindPhone', component: (resolve) => require(['@/page/bindPhone'], resolve), meta: {title: '认证手机号码'}},
    {path: '/changePhone', name: 'changePhone', component: (resolve) => require(['@/page/changePhone'], resolve), meta: {title: '修改手机号码'}},
    {path: '/userCenter', name: 'userCenter', component: (resolve) => require(['@/page/userCenter'], resolve), meta: {title: '博时乐教育'}},
    {path: '/switchUser', name: 'switchUser', component: (resolve) => require(['@/page/switchUser'], resolve), meta: {title: '账号切换'}},
    {path: '/userAdd', name: 'userAdd', component: (resolve) => require(['@/page/userAdd'], resolve), meta: {title: '账号添加'}},
    {path: '/userInfo', name: 'userInfo', component: (resolve) => require(['@/page/userInfo'], resolve), meta: {title: '账户信息'}},
    {path: '/userPay', name: 'userPay', component: (resolve) => require(['@/page/userPay'], resolve), meta: {title: '充值'}},
    {path: '/plan', name: 'plan', component: (resolve) => require(['@/page/plan'], resolve), meta: {title: '计划'}},
    {path: '/billList', name: 'billList', component: (resolve) => require(['@/page/billList'], resolve), meta: {title: '消费账单'}},
    {path: '/monthBillList', name: 'monthBillList', component: (resolve) => require(['@/page/monthBillList'], resolve), meta: {title: '消费月账单'}},
    {path: '/consumptionDetail', name: 'consumptionDetail', component: (resolve) => require(['@/page/consumptionDetail'], resolve), meta: {title: '账单详情'}},
    {path: '/login', name: 'login', component: (resolve) => require(['@/page/login'], resolve), meta: {title: '登陆'}},
    {path: '/500', name: '500', component: (resolve) => require(['@/page/500'], resolve), meta: {title: '出错啦~'}},
    {path: '/remark', name: 'remark', component: (resolve) => require(['@/page/remark'], resolve), meta: {title: '说明'}},
    {path: '/monthBillList2', name: 'monthBillList2', component: (resolve) => require(['@/page/monthBillList2'], resolve), meta: {title: '账单列表'}},
    {path: '/paySuccess', name: 'paySuccess', component: (resolve) => require(['@/page/paySuccess'], resolve), meta: {title: '充值成功'}},
    {path: '/waitBillList', name: 'waitBillList', component: (resolve) => require(['@/page/waitBillList'], resolve), meta: { title: '待支付账单' } },
    {path: '/waitBillDetails', name: 'waitBillDetails', component: (resolve) => require(['@/page/waitBillDetails'], resolve), meta: { title: '账单详情' } }
  ]
})
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js